import dynamic from 'next/dynamic';

import { MOBILE_55_VIDEO_ID } from '../enums/appLandingPageEnums';

const WistiaEmbed = dynamic(() => import('./WistiaEmbed'), {
  ssr: false,
});

export const MobileWistiaVideoPlayer = () => (
  <WistiaEmbed videoId={MOBILE_55_VIDEO_ID} type="mobile" />
);
